import { render, staticRenderFns } from "./Plan-detail.vue?vue&type=template&id=4f972917"
import script from "./Plan-detail.vue?vue&type=script&lang=js"
export * from "./Plan-detail.vue?vue&type=script&lang=js"
import style0 from "./Plan-detail.vue?vue&type=style&index=0&id=4f972917&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports